import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id A8AE1FBA-2DA6-47AA-9B12-910E7FCD8D43
 * name store-settings
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-settings.svg
 * tags
 * - Places 
 * - Shopping 
 * - Settings 
 */
export const StoreSettingsIcon = createSvgIcon(<><path d="M20 6H4V4H20V6M21 12V14H20V20H18V14H14V20H4V14H3V12L4 7H20L21 12M12 14H6V18H12V14M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z" /></>, 'StoreSettingsIcon');
export default StoreSettingsIcon